import { Helmet } from 'react-helmet-async';

const Categories = () => {
  return (
    <>
      <Helmet>
        <title>Categories | Admin | Panchali Boutique</title>
      </Helmet>
      <div className="space-y-6">
        <h1 className="text-3xl font-semibold">Categories</h1>
        {/* Categories content */}
      </div>
    </>
  );
};

export default Categories;